import { render, staticRenderFns } from "./MemberBenefit.vue?vue&type=template&id=413816c8&scoped=true&"
import script from "./MemberBenefit.vue?vue&type=script&lang=js&"
export * from "./MemberBenefit.vue?vue&type=script&lang=js&"
import style0 from "./MemberBenefit.vue?vue&type=style&index=0&id=413816c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413816c8",
  null
  
)

export default component.exports